import { type CanvasElementDefinition } from '../../canvas-elements/element-definition';

import { getDefaults, getInitial, getIoConfig, getPropsConfig } from './_base-chart.element';
import { DotChartDefinitionMapper } from './ai/chart.definition-mapper';
import { DotChartElementHandler } from './ai/dot-chart.element-handler';
import { ChartComponent } from './chart.component';
import { CHART_DIMENSIONS } from './chart.models';
import { ChartPropsBuilder } from './chart.props-builder';
import { ChartPropsExtractor } from './chart.props-extractor';
import { chartV2Migration } from './migrations/002-all-chart-types.migration';
import { chartV3Migration } from './migrations/003-chart.migration';

export function getDotChartDefinition(): CanvasElementDefinition<'chartDot'> {
  return {
    type: 'chartDot',
    componentType: ChartComponent<'chartDot'>,
    isListed: true,
    name: 'Vitals Chart',
    width: { mode: 'value', value: CHART_DIMENSIONS.width, fixed: true },
    height: { mode: 'value', value: CHART_DIMENSIONS.height, fixed: true },
    ioConfig: getIoConfig(),
    propsConfig: getPropsConfig('chartDot'),
    propsBuilder: ChartPropsBuilder,
    propsExtractor: ChartPropsExtractor,
    defaults: getDefaults('Vitals Chart'),
    initial: getInitial(),
    groups: ['charts'],
    styleIncludePaths: [
      'style',
      'content.font.fontFamily',
      'content.font.style',
      'content.font.fontSize',
      'content.title.iconPosition',
    ],
    features: {
      ai: {
        showAiPromptAutomatically: true,
        description: true,
      },
      visualStyle: 'block',
    },

    version: 3,
    migrations: {
      2: chartV2Migration,
      3: chartV3Migration,
    },
    ai: {
      name: 'chartDot',
      handler: () => DotChartElementHandler,
      definitionMapper: () => DotChartDefinitionMapper,
    },
  };
}
